import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';
import './calls-list-tab-skeleton.scss';

const DEFAULT_ROWS = 11;

export type CallsListTabSkeletonProps = {
  rows?: number;
};

/**
 * Placeholder rows matching the prospect Calls tab list (icon, date, duration,
 * outcome pill, link, time, chevron).
 */
const CallsListTabSkeleton: React.FC<CallsListTabSkeletonProps> = ({
  rows = DEFAULT_ROWS,
}) => (
  <ul
    className="bs-calls-list-tab__list bs-calls-list-tab-skeleton"
    aria-busy="true"
    aria-label="Loading calls"
  >
    <div className="bs-calls-list-tab-skeleton__header">
      <SkeletonLoading width={20} height={18} />
      <SkeletonLoading width={80} height={18} />
      <SkeletonLoading width={24} height={16} />
    </div>
    {Array.from({ length: rows })?.map((_, i) => (
      <li
        key={`calls-list-skeleton-${i}`}
        className="bs-calls-list-tab__item bs-calls-list-tab-skeleton__item"
      >
        <div className="bs-calls-list-tab-skeleton__row">
          <div className="bs-calls-list-tab-skeleton__left">
            <span className="bs-calls-list-tab-skeleton__icon-wrap">
              <SkeletonLoading width={20} height={20} />
            </span>
            <SkeletonLoading width={132} height={14} />
            <span className="bs-calls-list-tab-skeleton__pill">
              <SkeletonLoading width={36} height={20} />
            </span>
            <span className="bs-calls-list-tab-skeleton__pill bs-calls-list-tab-skeleton__pill--outcome">
              <SkeletonLoading width={96} height={22} />
            </span>
          </div>
          <div className="bs-calls-list-tab-skeleton__right">
            <SkeletonLoading width={52} height={12} />
            <span className="bs-calls-list-tab-skeleton__icon-wrap">
              <SkeletonLoading width={24} height={24} />
            </span>
          </div>
        </div>
      </li>
    ))}
  </ul>
);

export default CallsListTabSkeleton;
